// French -> English dictionary. Keys are the exact French UI strings.
export const DICT = {
  // ---- Navigation ----
  "Tableau de Bord": "Dashboard",
  "Nouveau Rapport": "New Report",
  "Rapports Quotidiens": "Daily Reports",
  "Indicateurs": "Indicators",
  "Carte": "Map",
  "Rapport Hebdomadaire": "Weekly Report",
  "Synthèse DOS": "DOS Summary",
  "Qualité des Données": "Data Quality",
  "Signaux & Alertes": "Signals & Alerts",
  "Recommandations": "Recommendations",
  "Zones de Santé": "Health Zones",
  "Provinces": "Provinces",
  "Labo · Tableau": "Lab · Dashboard",
  "Labo · Saisie": "Lab · Entry",
  "Import de Données": "Data Import",
  "Administration": "Administration",
  "Pilier Laboratoire": "Laboratory Pillar",
  "Système": "System",

  // ---- Header / chrome ----
  "République Démocratique du Congo · Pilier Surveillance": "Democratic Republic of Congo · Surveillance Pillar",
  "Données de démonstration": "Demo data",
  "Se déconnecter": "Sign out",

  // ---- Roles ----
  "Épidémiologiste de Terrain": "Field Epidemiologist",
  "Superviseur Provincial": "Provincial Supervisor",
  "Analyste SI": "SI Analyst",
  "Analyste SI / Data Manager": "SI Analyst / Data Manager",
  "Gestionnaire de Programme": "Program Manager",
  "Administrateur": "Administrator",
  "Administrateur Système": "System Administrator",

  // ---- Login ----
  "Connexion": "Sign in",
  "Accédez à votre espace de surveillance.": "Access your surveillance workspace.",
  "Adresse e-mail": "Email address",
  "Mot de passe": "Password",
  "Se connecter": "Sign in",
  "Comptes de démonstration": "Demo accounts",
  "Système de Surveillance Épidémiologique": "Epidemiological Surveillance System",
  "Standardisez les rapports quotidiens de terrain, calculez automatiquement les indicateurs de surveillance et générez les rapports hebdomadaires par Zone de Santé et Province · RDC.":
    "Standardize daily field reports, automatically compute surveillance indicators and generate weekly Health Zone and Province reports · DRC.",
  "Pilier Surveillance / Épidémiologie de Terrain": "Surveillance / Field Epidemiology Pillar",
  "Épidémiologiste de terrain": "Field epidemiologist",
  "Superviseur provincial": "Provincial supervisor",

  // ---- Page headers (titles) ----
  "Tableau de Bord Épidémiologique": "Epidemiological Dashboard",
  "Vue d'ensemble de la réponse de surveillance de terrain": "Overview of the field surveillance response",
  "Rapport Quotidien de Terrain": "Daily Field Report",
  "Modifier le Rapport": "Edit Report",
  "Saisie rapide (< 5 min) · répondez uniquement aux activités réalisées aujourd'hui": "Quick entry (< 5 min) · answer only for the activities you did today",
  "Base Centrale des Rapports Quotidiens": "Central Daily Reports Database",
  "Indicateurs de Surveillance": "Surveillance Indicators",
  "Calcul automatique · survolez l'icône pour la définition et la formule": "Automatically computed · hover the icon for the definition and formula",
  "Carte de Surveillance · RDC": "Surveillance Map · DRC",
  "Choroplèthe provincial + volume par Zone de Santé": "Provincial choropleth + volume by Health Zone",
  "Générateur de Rapport Hebdomadaire": "Weekly Report Generator",
  "Narratif automatique à partir des rapports quotidiens": "Automatic narrative from daily reports",
  "Synthèse Hebdomadaire DOS": "DOS Weekly Summary",
  "Points clés prêts à copier pour le briefing exécutif": "Key points ready to copy for the executive briefing",
  "Contrôle Qualité des Données": "Data Quality Control",
  "Complétude, promptitude, cohérence, doublons et valeurs aberrantes": "Completeness, timeliness, consistency, duplicates and outliers",
  "Signaux & Alertes de Surveillance": "Surveillance Signals & Alerts",
  "Détection automatique d'aide à la décision": "Automatic decision-support detection",
  "Suivi des Recommandations & Plan d'Action": "Recommendations & Action Tracker",
  "Recommandations issues des rapports quotidiens de terrain": "Recommendations from daily field reports",
  "Fiche Zone de Santé": "Health Zone Profile",
  "Profil épidémiologique détaillé par zone": "Detailed epidemiological profile per zone",
  "Profil Épidémiologique Provincial": "Provincial Epidemiological Profile",
  "Agrégation de toutes les zones de santé": "Aggregation of all health zones",
  "Utilisateurs, unités géographiques, données de référence et intégrations": "Users, geographic units, reference data and integrations",
  "Laboratoire · Tableau de Bord": "Laboratory · Dashboard",
  "Pilier Laboratoire · partage la même géographie et le même moteur d'indicateurs": "Laboratory pillar · shares the same geography and indicator engine",
  "Laboratoire · Nouveau Rapport": "Laboratory · New Report",
  "Saisie rapide des activités de laboratoire": "Quick entry of laboratory activities",
  "Import des Rapports Historiques": "Historical Report Import",
  "Téléversez d'anciens rapports Word/PDF/Excel · extraction assistée par IA avec validation obligatoire": "Upload old Word/PDF/Excel reports · AI-assisted extraction with mandatory validation",

  // ---- KPI labels ----
  "Rapports reçus": "Reports received",
  "Complétude": "Completeness",
  "Promptitude": "Timeliness",
  "Alertes reçues": "Alerts received",
  "Alertes investiguées": "Alerts investigated",
  "Cas suspects": "Suspected cases",
  "Contacts suivis": "Contacts followed",
  "FOSA visitées": "Facilities visited",
  "Sites communaut.": "Communities",
  "Épidémio. actifs": "Active epi.",
  "Défis prioritaires": "Priority challenges",
  "Recomm. en attente": "Pending recomm.",
  "Échantillons reçus": "Samples received",
  "Analysés": "Tested",
  "Taux de positivité": "Positivity rate",
  "Rejetés": "Rejected",
  "Résultats transmis": "Results transmitted",
  "Délai moyen (h)": "Avg turnaround (h)",
  "Recomm. ouvertes": "Open recomm.",
  "Prioritaires": "High priority",
  "En retard": "Overdue",
  "Résolues (semaine)": "Resolved (week)",
  "Score qualité moyen": "Avg quality score",
  "Rapports à anomalies": "Reports with issues",
  "Doublons potentiels": "Potential duplicates",
  "Valeurs aberrantes": "Outliers",

  // ---- Filters ----
  "Territoire": "Territory",
  "Zone de Santé": "Health Zone",
  "Épidémiologiste": "Epidemiologist",
  "Du": "From",
  "Au": "To",
  "Toutes": "All",
  "Tous": "All",
  "Réinitialiser": "Reset",
  "Indicateur affiché": "Displayed indicator",

  // ---- Status / priority / signal levels ----
  "Soumis": "Submitted",
  "Validé": "Validated",
  "Signalé": "Flagged",
  "Nouvelle": "New",
  "En revue": "Under review",
  "En cours": "In progress",
  "Résolue": "Resolved",
  "Clôturée": "Closed",
  "Critique": "Critical",
  "Élevée": "High",
  "Moyenne": "Medium",
  "Basse": "Low",
  "Urgent": "Urgent",
  "Important": "Important",
  "À surveiller": "Watch",
  "Informatif": "Informational",

  // ---- Weekly report sections & chrome ----
  "Aperçu de la notification": "Reporting overview",
  "Activités menées": "Activities conducted",
  "Indicateurs clés de surveillance": "Key surveillance indicators",
  "Constats clés": "Key findings",
  "Défis": "Challenges",
  "Réalisations / Impact": "Achievements / Impact",
  "Comparaison avec la semaine précédente": "Comparison with previous week",
  "Interprétation programmatique": "Programmatic interpretation",
  "Rapport de Surveillance": "Surveillance Report",
  "Semaine Épidémiologique": "Epidemiological Week",
  "au": "to",
  "Indicateur": "Indicator",
  "Semaine actuelle": "Current week",
  "Semaine précédente": "Previous week",
  "Évolution": "Change",
  "Niveau": "Level",
  "Semaine": "Week",
  "Année": "Year",
  "National / Programme": "National / Program",
  "Télécharger PDF": "Download PDF",
  "Imprimer": "Print",
  "Imprimer / PDF": "Print / PDF",
  "Génération…": "Generating…",
  "Aucun constat notable.": "No notable findings.",
  "Aucun défi signalé.": "No challenges reported.",
  "Aucune recommandation prioritaire non résolue.": "No high-priority unresolved recommendations.",
  "Aucune réalisation rapportée.": "No achievements reported.",
  "Aucune variation significative (≥15%).": "No significant change (≥15%).",
  "signalé": "reported",
  "fois": "times",
  "zones": "zones",
  "gravité": "severity",

  // ---- DOS report ----
  "Activités de surveillance": "Surveillance activities",
  "Réalisations clés": "Key achievements",
  "Défis majeurs": "Major challenges",
  "Recommandations prioritaires": "Priority recommendations",
  "Évolution semaine sur semaine": "Week-over-week change",
  "Export PowerPoint": "Export PowerPoint",
  "Aperçu": "Overview",
  "Complétude:": "Completeness:",
  "Aucune": "None",
  "Aucun": "None",
  "Aucune variation significative": "No significant change",

  // ---- Administration ----
  "Utilisateurs": "Users",
  "Géographie": "Geography",
  "Données de référence": "Reference data",
  "Intégrations": "Integrations",
  "Journal d'audit": "Audit log",
  "Nouvel utilisateur": "New user",
  "Nom": "Name",
  "Rôle": "Role",
  "Zone": "Zone",
  "Actif": "Active",
  "Province": "Province",
  "Les listes géographiques sont modifiables ici (ajout / suppression). Les suppressions sont bloquées si des utilisateurs ou rapports y sont rattachés.":
    "Geographic lists are editable here (add / remove). Deletions are blocked if users or reports are attached.",
  "Ajouter la province": "Add province",
  "Nom de la province": "Province name",
  "Ajouter un territoire": "Add territory",
  "Nom du territoire": "Territory name",
  "Ajouter une zone": "Add zone",
  "Zone de santé": "Health zone",
  "Latitude (optionnel)": "Latitude (optional)",
  "Longitude (optionnel)": "Longitude (optional)",
  "Ajouter": "Add",
  "Enregistré.": "Saved.",
  "Supprimé.": "Deleted.",
  "Confirmer la suppression ?": "Confirm deletion?",
  "Types d'activités": "Activity types",
  "Catégories de défis": "Challenge categories",
  "Catégories de constats": "Finding categories",
  "Indicateurs chiffrés": "Numeric indicators",
  "Maladies / événements": "Diseases / events",
  "Rôles utilisateurs": "User roles",
  "Configuration à venir": "Configuration coming soon",
  "Échange de données agrégées (optionnel)": "Aggregate data exchange (optional)",
  "L'architecture est modulaire et prête pour l'intégration de piliers additionnels (RCCE, PCI, EDS, etc.).":
    "The architecture is modular and ready for additional pillars (RCCE, IPC, SDB, etc.).",
  "Date": "Date",
  "Action": "Action",
  "Entité": "Entity",
  "Utilisateur": "User",
  "Détail": "Detail",
  "Nom complet": "Full name",
  "Annuler": "Cancel",
  "Créer": "Create",
  "Utilisateur créé.": "User created.",
  "URL du serveur": "Server URL",
  "Jeton API": "API token",
  "Enregistrer": "Save",
  "Importer maintenant": "Import now",
  "Journal d'import": "Import log",
  "Configuré": "Configured",
  "Configuration Kobo enregistrée.": "Kobo configuration saved.",

  // ---- Recommendations page ----
  "Statut": "Status",
  "Priorité": "Priority",
  "Recommandation": "Recommendation",
  "Identifié": "Identified",
  "Responsable": "Owner",
  "Échéance": "Due date",
  "Aucune recommandation.": "No recommendations.",
  "Gérer": "Manage",
  "Gérer la recommandation": "Manage recommendation",
  "Organisation": "Organization",
  "Commentaire de suivi": "Follow-up comment",
  "Recommandation mise à jour.": "Recommendation updated.",

  // ---- Data Quality page ----
  "Chargement…": "Loading…",
  "Complétude par Zone de Santé": "Completeness by Health Zone",
  "Rapports avec anomalies de cohérence": "Reports with consistency issues",
  "Score": "Score",
  "Anomalies": "Issues",
  "Aucune anomalie détectée.": "No issues detected.",
  "Valeurs aberrantes (alertes reçues vs plage attendue par zone)": "Outliers (alerts received vs expected range by zone)",
  "Valeur": "Value",
  "Plage attendue": "Expected range",
  "Complétude %": "Completeness %",

  // ---- Diseases / events ----
  "Maladie / événement": "Disease / event",
  "Choisir": "Select",
  "Identification": "Identification",
  "Laboratoire": "Laboratory",
  "Nom du labo": "Lab name",
  "Province *": "Province *",
  "Zone de Santé *": "Health Zone *",
  "Activités de laboratoire": "Laboratory activities",
  "Cochez · les champs chiffrés s'afficheront selon vos choix": "Check · numeric fields appear based on your selections",
  "Chiffres": "Figures",
  "Choléra": "Cholera",
  "Rougeole": "Measles",
  "Maladie à virus Ebola": "Ebola virus disease",
  "Mpox (variole simienne)": "Mpox (monkeypox)",
  "Fièvre jaune": "Yellow fever",
  "Méningite": "Meningitis",
  "Paludisme grave": "Severe malaria",
  "Peste": "Plague",
  "Décès maternel": "Maternal death",
  "PFA (Poliomyélite)": "AFP (Poliomyelitis)",
  "Autre": "Other",

  // ---- KPI sub-labels ----
  "sur": "of",
  "attendus": "expected",
  "Taux": "Rate",

  // ---- Profile / account ----
  "Mon Profil": "My Profile",
  "Profil": "Profile",
  "Préférences du compte": "Account preferences",
  "Langue de l'interface": "Interface language",
  "Langue mise à jour.": "Language updated.",
  "Informations du compte": "Account information",
  "Français": "French",
  "Anglais": "English",
  "Ce choix est mémorisé sur votre compte et appliqué à chaque connexion.": "This choice is saved to your account and applied at every login.",

  // ---- Pillar history ----
  "Historique des rapports": "Report history",
  "Exporter CSV": "Export CSV",
  "Exporter Excel": "Export Excel",
  "Aucun rapport.": "No reports.",
  "Activités": "Activities",
  "Auteur": "Author",
  "Note": "Note",

  // ---- Multi-pillar & pillar map ----
  "Tableau de Bord Multi-Piliers": "Multi-Pillar Dashboard",
  "Indicateurs clés des piliers par province, d'un seul coup d'œil": "Key pillar indicators by province, at a glance",
  "Cliquez une cellule de pilier pour ouvrir son tableau de bord détaillé.": "Click a pillar cell to open its detailed dashboard.",
  "Multi-Piliers": "Multi-Pillars",
  "Détail du rapport": "Report detail",
  "Carte du pilier": "Pillar map",
  "Indicateur cartographié": "Mapped indicator",
  "Localisation": "Location",
  "Aucune coordonnée disponible.": "No coordinates available.",

  // ---- Lab detail / multi-pillar map / email test ----
  "Rapports récents": "Recent reports",
  "Maladie": "Disease",
  "Technicien": "Technician",
  "Détail du rapport labo": "Lab report detail",
  "Carte comparative des piliers": "Comparative pillar map",
  "Pilier": "Pillar",
  "Voir": "View",
  "Test e-mail": "Email test",
  "Envoyer un test": "Send test",
  "E-mail de test envoyé.": "Test email sent.",
  "Adresse e-mail du destinataire": "Recipient email address",
  "Envoyer un e-mail de test pour vérifier la configuration des notifications (Resend).": "Send a test email to verify the notification (Resend) configuration.",

  // ---- Pillars / shared engine ----
  "Autres Piliers": "Other Pillars",
  "Prise en Charge": "Case Management",
  "EDS / SDB": "SDB / Safe Burials",
  "Saisie rapide · architecture partagée": "Quick entry · shared architecture",
  "Pilier · architecture partagée (géographie et indicateurs communs)": "Pillar · shared architecture (common geography & indicators)",
  "Activités réalisées": "Activities carried out",
  "Province et Zone de Santé requises.": "Province and Health Zone required.",
  "Sélectionnez au moins une activité.": "Select at least one activity.",
  "Rapport enregistré.": "Report saved.",
  "Tendance": "Trend",
  "par Zone de Santé": "by Health Zone",

  // ---- Signals ----
  "Analyse…": "Analyzing…",
  "Aucun signal détecté pour cette semaine.": "No signal detected for this week.",
  "Confirmer": "Confirm",
  "Rejeter": "Dismiss",
  "Signal marqué": "Signal marked",
  "Nouveau": "New",
  "Confirmé": "Confirmed",
  "Rejeté": "Dismissed",

  // ---- Targeted exports (Weekly) ----
  "Exports ciblés": "Targeted exports",
  "Téléchargez le rapport hebdomadaire par Province ou par Zone de Santé en un clic.": "Download the weekly report by Province or Health Zone in one click.",
  "Mon rapport (ma province)": "My report (my province)",
  "Télécharger toutes les zones": "Download all zones",
  "Rapport national": "National report",

  // ---- Dashboard cards ----
  "Tendance des rapports reçus": "Trend of reports received",
  "Alertes : reçues vs investiguées": "Alerts: received vs investigated",
  "Activité par Zone de Santé": "Activity by Health Zone",
  "Défis les plus fréquents": "Most frequent challenges",
  "Répartition des constats clés": "Breakdown of key findings",

  // ---- Lab cards ----
  "Tendance des échantillons": "Sample trend",
  "Taux de positivité par maladie": "Positivity rate by disease",
  "Échantillons par Zone de Santé": "Samples by Health Zone",
  "Nouveau rapport labo": "New lab report",

  // ---- Map / profiles ----
  "Choisir une zone": "Select a zone",
  "Aucune donnée pour cette zone.": "No data for this zone.",
  "Aucune donnée.": "No data.",

  // ---- Data import ----
  "Choisissez un fichier (.docx, .pdf, .xlsx).": "Choose a file (.docx, .pdf, .xlsx).",
  "Données extraites · veuillez valider avant enregistrement.": "Data extracted · please validate before saving.",
  "Date, province et zone de santé sont requis.": "Date, province and health zone are required.",
  "Rapport importé et enregistré dans la base.": "Report imported and saved to the database.",
  "Les données extraites par l'IA ne sont jamais enregistrées automatiquement. Vérifiez et corrigez chaque champ ci-dessous avant de confirmer l'ajout à la base.": "AI-extracted data is never saved automatically. Review and correct each field below before confirming.",

  // ---- Daily reports ----
  "Export démarré.": "Export started.",
  "rapport(s)": "report(s)",

  // ---- Indicators groups & labels ----
  "Notification": "Reporting",
  "Alertes": "Alerts",
  "Recherche des contacts": "Contact tracing",
  "Épidémiologie de terrain": "Field epidemiology",
  "Opérationnel": "Operational",
  "Rapports attendus": "Reports expected",
  "Complétude (%)": "Completeness (%)",
  "Promptitude (%)": "Timeliness (%)",
  "Taux d'investigation (%)": "Investigation rate (%)",
  "Taux de validation (%)": "Validation rate (%)",
  "Taux de suivi (%)": "Follow-up rate (%)",
  "Contacts perdus de vue": "Contacts lost to follow-up",
  "Investigations menées": "Investigations conducted",
  "Recherches actives": "Active searches",
  "Sites communautaires": "Community sites",
  "Supervisions": "Supervisions",
  "Revues qualité données": "Data quality reviews",
  "Défis signalés": "Challenges reported",
  "Recomm. résolues": "Resolved recomm.",

  // ---- New report sections ----
  "Pré-rempli depuis votre profil": "Pre-filled from your profile",
  "Activités réalisées aujourd'hui": "Activities carried out today",
  "Chiffres de surveillance": "Surveillance figures",
  "Zéro accepté · ne renseignez que ce qui est pertinent": "Zero accepted · fill only what is relevant",
  "Observation épidémiologique importante du jour": "Important epidemiological observation of the day",
  "Défis rencontrés": "Challenges encountered",
  "Recommandations / Actions requises": "Recommendations / Required actions",
  "Alimente automatiquement le suivi des recommandations": "Automatically feeds the recommendations tracker",
  "Succès / Impact (optionnel)": "Success / Impact (optional)",
  "Quel résultat positif a été obtenu aujourd'hui ?": "What positive outcome was achieved today?",

  // ---- Alerts history + digest schedule + multi-pillar extras ----
  "Historique des Alertes": "Alerts History",
  "E-mails de signaux et résumés envoyés, avec date et destinataires": "Signal and digest emails sent, with date and recipients",
  "Type d'e-mail": "Email type",
  "Tous les types": "All types",
  "Alerte de signal": "Signal alert",
  "Résumé hebdomadaire": "Weekly digest",
  "E-mail de test": "Test email",
  "Aucun e-mail envoyé pour le moment.": "No email sent yet.",
  "Sujet": "Subject",
  "Destinataires": "Recipients",
  "Signaux": "Signals",
  "Indicateurs clés": "Key indicators",
  "Planification du résumé hebdomadaire": "Weekly digest schedule",
  "Choisissez le jour et l'heure d'envoi automatique du résumé aux gestionnaires (fuseau horaire de Kinshasa).": "Choose the day and time the digest is automatically sent to managers (Kinshasa timezone).",
  "Jour d'envoi": "Send day",
  "Heure (Kinshasa)": "Time (Kinshasa)",
  "Envoyer le résumé maintenant": "Send digest now",
  "Planification enregistrée.": "Schedule saved.",
  "Résumé en cours d'envoi aux gestionnaires.": "Digest is being sent to managers.",
  "Lundi": "Monday",
  "Mardi": "Tuesday",
  "Mercredi": "Wednesday",
  "Jeudi": "Thursday",
  "Vendredi": "Friday",
  "Samedi": "Saturday",
  "Dimanche": "Sunday",
  "Carte choroplèthe des piliers": "Pillar choropleth map",
  "Provinces colorées selon l'indicateur": "Provinces shaded by the selected indicator",
  "Faible": "Low",
  "Élevé": "High",
  "Les cercles indiquent le volume par Zone de Santé": "Circles show the volume per Health Zone",

  // ---- Signal thresholds + DHIS2 ----
  "Seuils des signaux": "Signal thresholds",
  "Seuils de détection des signaux": "Signal detection thresholds",
  "Ajustez les seuils utilisés par la détection automatique des signaux et les alertes par e-mail.": "Adjust the thresholds used by automatic signal detection and email alerts.",
  "Enregistrer les seuils": "Save thresholds",
  "Seuils enregistrés.": "Thresholds saved.",
  "Létalité (CFR) : seuil Urgent (%)": "Case fatality (CFR): Urgent threshold (%)",
  "CFR : minimum de cas suspects": "CFR: minimum suspected cases",
  "CFR : minimum de décès": "CFR: minimum deaths",
  "Mortalité inhabituelle : décès par zone": "Unusual mortality: deaths per zone",
  "Hausse par zone : seuil (%)": "Per-zone surge: threshold (%)",
  "Hausse par zone : minimum requis": "Per-zone surge: minimum required",
  "Alertes nationales : seuil Urgent (%)": "National alerts: Urgent threshold (%)",
  "Cas nationaux : seuil Urgent (%)": "National cases: Urgent threshold (%)",
  "Complétude basse : seuil (%)": "Low completeness: threshold (%)",
  "Mappage des unités d'organisation et éléments de données, puis export agrégé par semaine (mode simulation).": "Map organisation units and data elements, then export aggregated values per week (simulation mode).",
  "URL du serveur DHIS2": "DHIS2 server URL",
  "Identifiant du jeu de données (dataSet)": "Data set identifier (dataSet)",
  "Unités d'organisation (province → orgUnit)": "Organisation units (province → orgUnit)",
  "Éléments de données (pilier → dataElement)": "Data elements (pillar → dataElement)",
  "Enregistrer le mappage": "Save mapping",
  "Configuration DHIS2 enregistrée.": "DHIS2 configuration saved.",
  "Exporter (simulation)": "Export (simulation)",
  "Export simulé généré avec succès.": "Simulated export generated successfully.",
  "Export simulé généré, mais": "Simulated export generated, but",
  "valeur(s) non mappée(s).": "unmapped value(s).",

  // ---- Monthly Report module (MVE) ----
  "Rapport Mensuel": "Monthly Report",
  "Riposte MVE · Experts de terrain": "EVD Response · Field experts",
  "Rapports mensuels structurés des épidémiologistes, laboratoires et autres piliers": "Structured monthly reports from epidemiologists, laboratories and other pillars",
  "Nouveau rapport mensuel": "New monthly report",
  "Aucun rapport mensuel pour le moment.": "No monthly report yet.",
  "Période": "Period",
  "Volet": "Section",
  "Province / Zones": "Province / Zones",
  "Brouillon": "Draft",
  "Supprimer ce rapport ?": "Delete this report?",
  "Rapport supprimé.": "Report deleted.",
  "Autre pilier": "Other pillar",
  "Technicien de laboratoire": "Laboratory technician",
  "Riposte MVE": "EVD Response",
  "Rapport mensuel": "Monthly report",
  "Complétez chaque section selon le canevas et les consignes de cadrage": "Complete each section following the template and framing guidance",
  "Retour aux rapports": "Back to reports",
  "Soumettre": "Submit",
  "Zone(s) de santé": "Health zone(s)",
  "Mois": "Month",
  "Rapport N°": "Report No.",
  "Ajouter une ligne": "Add a row",
  "Aucune ligne. Cliquez « Ajouter une ligne ».": "No rows. Click \"Add a row\".",
  "Téléverser une photo": "Upload a photo",
  "Photo ajoutée.": "Photo added.",
  "Légende": "Caption",
  "GPS": "GPS",
  "Retirer": "Remove",
  "Enregistrez d'abord le rapport.": "Save the report first.",

  // ---- Agent identity / roles ----
  "Identité de l'agent et préférences du compte": "Agent identity and account preferences",
  "Identité de l'agent": "Agent identity",
  "Identité & affectation": "Identity & assignment",
  "Matricule": "Staff ID",
  "Téléphone": "Phone",
  "Fonction / poste": "Role / position",
  "Projet": "Project",
  "Point focal / superviseur": "Focal point / supervisor",
  "Changer la photo": "Change photo",
  "Photo mise à jour.": "Photo updated.",
  "Informations pour le rapport": "Information for reporting",
  "Enregistrer le profil": "Save profile",
  "Profil mis à jour.": "Profile updated.",
  "Le rôle, le matricule et l'affectation sont assignés par l'administrateur.": "Role, staff ID and assignment are set by the administrator.",
  "Mon compte": "My account",
  "Aperçu graphique (auto)": "Visual preview (auto)",
  "Pyramide des âges et du sexe": "Age & sex pyramid",
  "Courbe hebdomadaire": "Weekly curve",
  "Complétez la liste de contrôle avant de soumettre.": "Complete the checklist before submitting.",
  "Modifier l'utilisateur": "Edit user",
  "Utilisateur mis à jour.": "User updated.",
  "Actions": "Actions",
  "Photo": "Photo",
  "Téléverser": "Upload",
  "laisser vide pour conserver": "leave blank to keep",

  // ---- Harmonized reporting workflow
  "Rapportage harmonisé": "Harmonized reporting",
  "Saisie Quotidienne": "Daily Entry",
  "Rapports Générés": "Generated Reports",
  "Registre de Saisie": "Entry Register",
  "Saisie unique harmonisée": "Single harmonized entry",
  "Saisie quotidienne": "Daily entry",
  "Les champs sont issus du cadre de rapportage mensuel. Les produits quotidien, hebdomadaire et mensuel en sont dérivés automatiquement.": "Fields come from the monthly reporting framework. The daily, weekly and monthly products are derived from them automatically.",
  "Date de la saisie": "Entry date",
  "Cadre harmonisé · chaque indicateur porte sa fréquence de collecte.": "Harmonized framework · each indicator carries its collection frequency.",
  "Quotidien": "Daily",
  "Hebdomadaire": "Weekly",
  "Mensuel": "Monthly",
  "Notes et analyse du jour": "Notes and analysis of the day",
  "Ces notes sont reportées automatiquement, par thème, dans les rapports hebdomadaire et mensuel. Une note marquée « Confidentiel » reste visible uniquement par vous, votre superviseur provincial et l'Analyste SI : elle est exclue des rapports agrégés et des exports.": "These notes are carried forward automatically, by theme, into the weekly and monthly reports. A note marked \"Confidential\" stays visible only to you, your provincial supervisor and the IS analyst: it is excluded from aggregated reports and exports.",
  "Confidentiel": "Confidential",
  "Partagé": "Shared",
  "Générer un produit de rapportage": "Generate a reporting product",
  "Les brouillons sont aussi générés automatiquement (fin de journée, fin de semaine épidémiologique, fin de mois) et doivent être validés et signés avant soumission.": "Drafts are also generated automatically (end of day, end of epi week, end of month) and must be validated and signed before submission.",
  "Rapport quotidien": "Daily report",
  "Rapport hebdomadaire": "Weekly report",
  "Saisie enregistrée.": "Entry saved.",
  "Brouillon généré.": "Draft generated.",

  // ---- Generated reports
  "Produits dérivés": "Derived products",
  "Rapports générés": "Generated reports",
  "Brouillons quotidiens et hebdomadaires dérivés de la saisie unique. À valider et signer avant soumission.": "Daily and weekly drafts derived from the single entry. To be validated and signed before submission.",
  "Générer le quotidien": "Generate the daily",
  "Générer l'hebdomadaire": "Generate the weekly",
  "Quotidiens": "Daily",
  "Hebdomadaires": "Weekly",
  "À contresigner": "To counter-sign",
  "Aucun rapport hebdomadaire n'attend votre contreseing.": "No weekly report is awaiting your counter-signature.",
  "rapport(s) hebdomadaire(s) validé(s) par leur auteur et en attente de votre contreseing avant consolidation nationale.": "weekly report(s) validated by their author and awaiting your counter-signature before national consolidation.",
  "Aucun brouillon généré pour le moment.": "No draft generated yet.",
  "Portée": "Scope",
  "Saisies": "Entries",
  "Consolidé": "Consolidated",
  "auto": "auto",

  // ---- Derived report detail
  "Rapport hebdomadaire dérivé": "Derived weekly report",
  "Rapport quotidien dérivé": "Derived daily report",
  "saisie(s) agrégée(s)": "aggregated entry(ies)",
  "Régénérer": "Regenerate",
  "Validé et signé par": "Validated and signed by",
  "en attente du contreseing du superviseur provincial": "awaiting the provincial supervisor's counter-signature",
  "Consolidé · double signature": "Consolidated · double signature",
  "puis": "then",
  "Indicateurs agrégés (auto)": "Aggregated indicators (auto)",
  "Période précédente": "Previous period",
  "Variation": "Change",
  "Aucune valeur saisie sur la période.": "No value entered for the period.",
  "Analyse narrative": "Narrative analysis",
  "Les notes de terrain de la période sont reportées par thème. Le copilote peut proposer une rédaction, toujours modifiable.": "The period's field notes are carried forward by theme. The copilot can draft the wording, always editable.",
  "Copilote": "Copilot",
  "note(s) confidentielle(s) masquée(s) pour votre profil.": "confidential note(s) hidden for your profile.",
  "Validation et signature": "Validation and signature",
  "Un brouillon doit être relu, signé et validé avant soumission. Les rapports hebdomadaires exigent ensuite le contreseing du superviseur provincial avant consolidation nationale.": "A draft must be reviewed, signed and validated before submission. Weekly reports then require the provincial supervisor's counter-signature before national consolidation.",
  "Nom et prénom du validateur": "Validator's first and last name",
  "Valider et signer": "Validate and sign",
  "Mettre à jour la signature": "Update the signature",
  "Contresigner (superviseur)": "Counter-sign (supervisor)",
  "Déjà contresigné": "Already counter-signed",
  "Modifications enregistrées.": "Changes saved.",
  "Indicateurs recalculés depuis les saisies.": "Indicators recomputed from the entries.",
  "Proposition du copilote insérée. Relisez et ajustez.": "Copilot suggestion inserted. Review and adjust.",
  "Rapport validé et signé.": "Report validated and signed.",
  "Rapport contresigné et consolidé.": "Report counter-signed and consolidated.",
  "PDF téléchargé.": "PDF downloaded.",

  // ---- Entry register
  "Suivi de complétude": "Completeness tracking",
  "Registre de saisie": "Entry register",
  "Qui a saisi et qui n'a pas encore saisi, pour relancer les agents en retard.": "Who has submitted and who has not, so late agents can be followed up.",
  "Agents attendus": "Expected agents",
  "Ont saisi": "Submitted",
  "Taux de saisie": "Entry rate",
  "Agents à relancer": "Agents to follow up",
  "Agent": "Agent",
  "Saisie du jour": "Today's entry",
  "Champs": "Fields",
  "Dernière saisie": "Last entry",
  "7 derniers jours": "Last 7 days",
  "Saisie faite": "Submitted",
  "Manquante": "Missing",
  "Aucun agent dans votre périmètre.": "No agent within your scope.",
  "Épidémiologie": "Epidemiology",
  "CREC / RCCE": "RCCE",
  "PCI": "IPC",
  "Prise en charge": "Case management",

  // ---- Confidentiality and visibility
  "Confidentialité": "Confidentiality",
  "Confidentialité et visibilité des saisies": "Entry confidentiality and visibility",
  "Chaque saisie est nominative et horodatée (voir le journal d'audit). Ces règles déterminent qui peut consulter les données des autres.": "Every entry is named and time-stamped (see the audit log). These rules decide who can view other people's data.",
  "Visibilité d'équipe par zone de santé": "Team visibility by health zone",
  "Activée : les agents d'une même zone de santé voient les saisies de leur zone (lecture seule, seul l'auteur peut modifier) et partagent un rapport hebdomadaire de zone. Désactivée : chacun ne voit que ses propres saisies.": "On: agents of the same health zone see their zone's entries (read-only, only the author can edit) and share one zone weekly report. Off: each agent sees only their own entries.",
  "Piliers en accès restreint": "Restricted-access pillars",
  "Les données d'un pilier restreint ne sont visibles que par ses propres agents, l'Analyste SI et l'Administrateur (le superviseur provincial et le gestionnaire de programme en sont exclus).": "A restricted pillar's data is visible only to its own agents, the IS analyst and the administrator (the provincial supervisor and programme manager are excluded).",
  "Enregistrer les règles": "Save the rules",
  "Règles de confidentialité enregistrées.": "Confidentiality rules saved.",
  "Anonymiser (matricule)": "Anonymise (staff ID)",
  "Remplace les noms des agents par leur matricule dans l'export": "Replaces agent names by their staff ID in the export",

  // ---- PowerBI
  "Connexion PowerBI": "PowerBI connection",
  "Flux web sécurisé par jeton (PowerBI › Obtenir les données › Web) et export de fichier pour un import manuel.": "Token-secured web feed (PowerBI › Get data › Web) and file export for a manual import.",
  "Jeu de données": "Dataset",
  "URL du flux à coller dans PowerBI": "Feed URL to paste into PowerBI",
  "Copier": "Copy",
  "URL copiée.": "URL copied.",
  "Aucun jeton actif : générez-en un pour activer le flux.": "No active token: generate one to enable the feed.",
  "Générer le jeton": "Generate the token",
  "Régénérer le jeton": "Regenerate the token",
  "Nouveau jeton généré. Mettez à jour l'URL dans PowerBI.": "New token generated. Update the URL in PowerBI.",
  "Le jeton donne accès en lecture aux données agrégées (aucune note confidentielle n'est exposée). Régénérez-le si l'URL a été partagée par erreur.": "The token grants read access to aggregated data (no confidential note is exposed). Regenerate it if the URL was shared by mistake.",
  "Modèle prêt à l'emploi pour l'équipe SI": "Ready-made template for the IS team",
  "Le fichier .pbids ouvre PowerBI Desktop déjà connecté au flux. Le script Power Query contient les trois requêtes (saisies, indicateurs, complétude) à coller tel quel.": "The .pbids file opens PowerBI Desktop already connected to the feed. The Power Query script contains the three queries (entries, indicators, completeness) ready to paste.",
  "Fichier PowerBI (.pbids)": "PowerBI file (.pbids)",
  "Script Power Query (.m)": "Power Query script (.m)",
  "Modèle téléchargé.": "Template downloaded.",
  "Générez d'abord un jeton PowerBI.": "Generate a PowerBI token first.",

  // ---- Bulk accounts
  "Créer plusieurs comptes": "Create several accounts",
  "Créer plusieurs comptes nominatifs": "Create several named accounts",
  "Une ligne par personne : Nom complet ; e-mail ; rôle ; province ; zone de santé. Les deux derniers champs sont optionnels pour les profils nationaux.": "One line per person: Full name ; email ; role ; province ; health zone. The last two fields are optional for national profiles.",
  "Mot de passe provisoire commun": "Shared provisional password",
  "Créer les comptes": "Create the accounts",
  "compte(s) créé(s)": "account(s) created",
  "ligne(s) ignorée(s)": "line(s) skipped",
  "Fermer": "Close",

  // ---- Map completeness
  "Complétude de saisie (%)": "Entry completeness (%)",
  "Les provinces sont colorées (choroplèthe) et les cercles indiquent le volume par zone de santé.": "Provinces are shaded (choropleth) and the circles show the volume per health zone.",
  "sans agent affecté": "no agent assigned",
  "aucun agent affecté": "no agent assigned",
  "saisies": "entries",
  "agent(s)": "agent(s)",
  "dernière": "last",
  "jamais": "never",
  "Retour": "Back",
  "Mon espace": "My workspace",
  "Mes tâches du moment": "My current tasks",
  "Rapport du jour": "Today's report",
  "À soumettre": "To submit",
  "Alertes à investiguer": "Alerts to investigate",
  "Échantillons en attente": "Pending samples",
  "Recommandations en attente": "Pending recommendations",
  "Rapports signalés": "Flagged reports",
  "Mes rapports (semaine)": "My reports (week)",
  "Semaine épidémiologique": "Epidemiological week",
  "aucun rapport récent": "no recent report",
  "dernier rapport": "last report",
  "Cas": "Cases",
  "Cas confirmés": "Confirmed cases",
  "Courbe épidémique hebdomadaire": "Weekly epidemic curve",
  "Courbe épidémique · cas confirmés par semaine": "Epidemic curve · confirmed cases per week",
  "Rapports": "Reports",
  "Type": "Type",
  "Journée du": "Day of",
  "(équipe)": "(team)",
  "Aire de Santé": "Health Area",
  "Province / Territoire": "Province / Territory",
  "Score qualité": "Quality score",
  "Semaine épi.": "Epi week",
  "Zones actives": "Active zones",
  "Septembre": "September",
  "insérés": "inserted",
  "doublons": "duplicates",
  "invalides": "invalid",

  // ---- Chart legends, tables and actions missed in the first pass
  "Investiguées": "Investigated",
  "Reçues": "Received",
  "Signalements": "Flagged items",
  "Alertes par Zone de Santé": "Alerts by Health Zone",
  "Trier par rapports": "Sort by reports",
  "Trier par alertes": "Sort by alerts",
  "Trier par cas suspects": "Sort by suspected cases",
  "Trier par complétude": "Sort by completeness",
  "Précédent": "Previous",
  "Suivant": "Next",
  "Ajouter un constat": "Add a finding",
  "Ajouter un défi": "Add a challenge",
  "Ajouter une recommandation": "Add a recommendation",
  "Veuillez sélectionner la Province et la Zone de Santé.": "Please select the Province and the Health Zone.",
  "S": "W",
  "Surveillance / Épidémiologie": "Surveillance / Epidemiology",
  "Laboratoire / Diagnostic": "Laboratory / Diagnostics",
  "CREC / Communication des risques": "RCCE / Risk communication",
  "EDS / Enterrement Digne et Sécurisé": "SDB / Safe and Dignified Burials",
  "PCI / Prévention et Contrôle des Infections": "IPC / Infection Prevention and Control",
  "Prise en charge des cas": "Case management",
  "Prise en Charge des Cas": "Case management",
  "Logistique": "Logistics",
  "Préparation": "Preparedness",
  "Épidémiologie / Surveillance": "Epidemiology / Surveillance",
  "Invest.": "Invest.",
  "Cas susp.": "Susp. cases",
  "Contacts identifiés": "Contacts identified",
  "Rapport du": "Report of",
  "Constats": "Findings",
  "Sélectionnez au moins une activité réalisée.": "Select at least one activity carried out.",
  "Rapport mis à jour.": "Report updated.",
  "Rapport quotidien soumis avec succès.": "Daily report submitted successfully.",
  "Saisies quotidiennes harmonisées (une ligne par agent/jour/indicateur)": "Harmonized daily entries (one row per agent/day/indicator)",
  "Indicateurs hebdomadaires agrégés (rapports dérivés)": "Aggregated weekly indicators (derived reports)",
  "Complétude de saisie par agent et par jour": "Entry completeness by agent and by day",
  "Éditer": "Edit",
  "Valider": "Validate",
  "Signaler": "Flag",
  "Rapport validé": "Report validated",
  "Rapport signalé": "Report flagged",
  "Soumettre le rapport": "Submit the report",
  "À corriger": "To correct",
  "Rapport consolidé.": "Report consolidated.",
  "À valider": "To validate",
  "Circuit de validation": "Validation workflow",
  "L'auteur rédige puis soumet son rapport. Seuls le superviseur provincial et l'Administrateur peuvent le valider et le signer ; l'Administrateur le consolide ensuite.": "The author drafts then submits the report. Only the provincial supervisor and the administrator can validate and sign it; the administrator then consolidates it.",
  "Soumettre pour validation": "Submit for validation",
  "Déjà soumis": "Already submitted",
  "La validation est réservée au superviseur provincial et à l'Administrateur.": "Validation is restricted to the provincial supervisor and the administrator.",
  "Rapport soumis pour validation.": "Report submitted for validation.",
  "Soumis pour validation par": "Submitted for validation by",
  "en attente du superviseur provincial ou de l'Admin": "awaiting the provincial supervisor or the admin",
  "Renvoyer pour correction": "Send back for correction",
  "Renvoyé pour correction par": "Sent back for correction by",
  "Motif du renvoi à l'auteur :": "Reason for sending it back to the author:",
  "Rapport renvoyé à son auteur.": "Report sent back to its author.",
  "Consolider (Admin)": "Consolidate (Admin)",
  "Aucun rapport hebdomadaire n'attend votre validation.": "No weekly report is awaiting your validation.",
  "rapport(s) hebdomadaire(s) soumis par leur auteur et en attente de votre validation et signature.": "weekly report(s) submitted by their author and awaiting your validation and signature.",
  "Technicien de Laboratoire": "Laboratory Technician",
  "Agent Prise en Charge": "Case Management Officer",
  "Agent CREC / RCCE": "RCCE Officer",
  "Agent EDS / SDB": "SDB Officer",
  "Agent PCI": "IPC Officer",

  // ---- Validation trail ----
  "Historique de validation": "Validation history",
  "Piste d'audit visible par le superviseur provincial et l'Administrateur.": "Audit trail visible to the provincial supervisor and the administrator.",
  "Aucun événement enregistré pour ce rapport.": "No event recorded for this report.",
  "Brouillon généré": "Draft generated",
  "Intégré au rapport provincial consolidé": "Merged into the provincial consolidated report",

  // ---- Mode hors ligne (PWA) ----
  "Hors ligne · vos saisies sont enregistrées sur l'appareil": "Offline · your entries are stored on this device",
  "Connexion rétablie": "Back online",
  "saisie(s) en attente": "entry(ies) pending",
  "Synchroniser maintenant": "Sync now",
  "saisie(s) synchronisée(s) avec le serveur.": "entry(ies) synced with the server.",
  "Aucune saisie en attente.": "No pending entry.",
  "Toujours hors ligne. Les saisies restent en attente.": "Still offline. Entries stay in the queue.",
  "Saisie enregistrée sur l'appareil. Elle sera envoyée au retour du réseau.": "Entry saved on this device. It will be sent when the network is back.",
  "Enregistré sur l'appareil, en attente d'envoi": "Saved on this device, waiting to be sent",
  "Mode hors ligne · formulaire chargé depuis l'appareil.": "Offline mode · form loaded from this device.",
  "Hors ligne et formulaire non encore téléchargé. Connectez-vous une fois au réseau.": "Offline and the form has not been downloaded yet. Connect to the network once.",
  "La génération des rapports nécessite une connexion.": "Generating reports requires a connection.",
  "Données hors ligne · dernier rafraîchissement le": "Offline data · last refreshed on",
  "Hors ligne · lecture seule": "Offline · read only",
  "les actions de validation nécessitent une connexion": "validation actions require a connection",
  "Hors ligne et aucun rapport encore téléchargé.": "Offline and no report downloaded yet.",
  "Hors ligne et ce rapport n'a pas encore été téléchargé.": "Offline and this report has not been downloaded yet.",
  "PDF hors ligne (dernière version téléchargée).": "Offline PDF (last downloaded version).",
  "PDF indisponible hors ligne : ouvrez-le une fois connecté.": "PDF unavailable offline: open it once while connected.",
  "Installer Stride sur mon téléphone": "Install Stride on my phone",
  "L'application s'ouvre en plein écran et la saisie quotidienne reste disponible hors réseau.": "The app opens full screen and daily entry stays available without network.",
  "Sur iPhone : Partager, puis « Sur l'écran d'accueil ».": "On iPhone: Share, then \"Add to Home Screen\".",
  "Installer": "Install",
  "Photos de terrain": "Field photos",
  "Jusqu'à 3 photos par saisie, compressées automatiquement. Visibles par vous, votre superviseur provincial et l'Administrateur, et annexées au PDF du rapport.": "Up to 3 photos per entry, compressed automatically. Visible to you, your provincial supervisor and the administrator, and annexed to the report PDF.",
  "Ajouter une photo": "Add a photo",
  "Photo conservée sur l'appareil, envoyée à la synchronisation.": "Photo kept on the device, sent at sync time.",
  "Photo illisible.": "Unreadable photo.",
  "Maximum": "Maximum",
  "photos par saisie.": "photos per entry.",
  "en attente": "pending",
  "Supprimer": "Delete",
  "photo(s) non affichée(s) pour votre profil.": "photo(s) hidden for your profile.",

  // ---- Consolidated provincial report ----
  "Rapport Consolidé": "Consolidated Report",
  "Coordination provinciale": "Provincial coordination",
  "Fusionnez les rapports hebdomadaires validés de votre province en un rapport provincial unique.": "Merge the validated weekly reports of your province into a single provincial report.",
  "Nouvelle consolidation": "New consolidation",
  "Charger les rapports validés": "Load validated reports",
  "Aucun rapport hebdomadaire validé pour cette semaine dans": "No validated weekly report for that week in",
  "rapport(s) validé(s) disponible(s)": "validated report(s) available",
  "Consolider la sélection": "Consolidate selection",
  "Rapport provincial consolidé généré.": "Provincial consolidated report generated.",
  "Aucun rapport consolidé pour le moment.": "No consolidated report yet.",
  "Supprimer ce rapport consolidé ?": "Delete this consolidated report?",
  "Rapport consolidé supprimé.": "Consolidated report deleted.",
  "Rapport provincial consolidé": "Provincial consolidated report",
  "rapport(s) fusionné(s)": "merged report(s)",
  "Rapports sources": "Source reports",
  "Total provincial": "Provincial total",
  "Aucune valeur agrégée.": "No aggregated value.",
  "Validation du rapport provincial": "Provincial report validation",
  "Titre du rapport": "Report title",
  "Rapport provincial validé et signé.": "Provincial report validated and signed.",
  "Validé par": "Validated by",
  "Le rapport mensuel nécessite une connexion. Saisie conservée sur l'appareil.": "The monthly report requires a connection. Entry kept on the device.",
  "Rapport généré hors ligne. Il sera envoyé au serveur à la reconnexion.": "Report generated offline. It will be sent to the server when back online.",
  "Hors ligne, les rapports quotidien et hebdomadaire sont calculés sur l'appareil puis envoyés au serveur à la reconnexion.": "Offline, daily and weekly reports are computed on the device and sent to the server when back online.",
  "Généré hors ligne · envoyé au serveur à la reconnexion": "Generated offline · sent to the server when back online",
  "Ce rapport hors ligne a déjà été synchronisé.": "This offline report has already been synchronised.",
  "Modifications conservées sur l'appareil.": "Changes kept on the device.",
  "Rapport généré hors ligne sur cet appareil": "Report generated offline on this device",
  "il sera envoyé au serveur à la reconnexion ; vous pourrez ensuite le soumettre et télécharger le PDF.": "it will be sent to the server when back online; you can then submit it and download the PDF.",
  "rapport(s) généré(s) hors ligne envoyé(s) au serveur.": "offline-generated report(s) sent to the server.",
  "rapport(s) à envoyer": "report(s) to send",
  "Télécharger Stride": "Download Stride",
  "Installation": "Installation",
  "Installez Stride sur votre ordinateur ou votre téléphone pour travailler même sans réseau.": "Install Stride on your computer or phone to work even without a network.",
  "Installation immédiate depuis le navigateur (recommandée)": "Instant install from the browser (recommended)",
  "Sur Chrome ou Edge, Stride s'installe en un clic : icône sur le bureau ou l'écran d'accueil, fenêtre dédiée, saisie et génération des rapports hors ligne, mises à jour automatiques.": "On Chrome or Edge, Stride installs in one click: desktop/home-screen icon, dedicated window, offline entry and report generation, automatic updates.",
  "Stride est déjà installé sur cet appareil.": "Stride is already installed on this device.",
  "Installer Stride maintenant": "Install Stride now",
  "Chrome / Edge : icône « Installer » à droite de la barre d'adresse, ou menu ⋮ › « Installer Stride ». iPhone : Partager › « Sur l'écran d'accueil ».": "Chrome / Edge: \"Install\" icon at the right of the address bar, or menu ⋮ › \"Install Stride\". iPhone: Share › \"Add to Home Screen\".",
  "Logiciel de bureau Stride": "Stride desktop software",
  "Au premier lancement, choisissez le mode de fonctionnement du poste :": "On first launch, choose how this computer will work:",
  "Connecté au serveur": "Connected to the server",
  "Données partagées avec les superviseurs et l'équipe SI. Fonctionne hors ligne et se synchronise au retour du réseau.": "Data shared with supervisors and the IS team. Works offline and syncs when the network returns.",
  "Autonome (100 % local)": "Standalone (100% local)",
  "Base de données et serveur embarqués sur l'ordinateur. Aucune connexion nécessaire ; les données restent sur ce poste.": "Database and server embedded on the computer. No connection needed; data stays on this machine.",
  "Installateur (.exe). Double-cliquez, puis suivez l'assistant.": "Installer (.exe). Double-click and follow the wizard.",
  "Image disque (.dmg). Glissez Stride dans Applications.": "Disk image (.dmg). Drag Stride into Applications.",
  "AppImage (ou .deb pour Ubuntu/Debian). Rendez le fichier exécutable.": "AppImage (or .deb for Ubuntu/Debian). Make the file executable.",
  "Fourni par votre administrateur": "Provided by your administrator",
  "Installer Stride sur cet appareil": "Install Stride on this device",
  "Icône sur le bureau ou l'écran d'accueil, fenêtre dédiée, saisie et rapports même sans réseau.": "Desktop or home-screen icon, dedicated window, entries and reports even without a network.",
  "Masquer les étapes": "Hide the steps",
  "Comment installer ?": "How to install?",
  "Ouvrez cette page dans Safari.": "Open this page in Safari.",
  "Touchez le bouton Partager (carré avec une flèche).": "Tap the Share button (square with an arrow).",
  "Choisissez « Sur l'écran d'accueil » puis « Ajouter ».": "Choose \"Add to Home Screen\" then \"Add\".",
  "Ordinateur (Chrome / Edge) : cliquez sur l'icône « Installer » à droite de la barre d'adresse, ou menu ⋮ › « Installer Stride ».": "Computer (Chrome / Edge): click the \"Install\" icon at the right of the address bar, or menu ⋮ › \"Install Stride\".",
  "Android (Chrome) : menu ⋮ › « Ajouter à l'écran d'accueil » ou « Installer l'application ».": "Android (Chrome): menu ⋮ › \"Add to Home screen\" or \"Install app\".",
  "Stride s'ouvre ensuite depuis son icône, comme un logiciel classique.": "Stride then opens from its icon, like a regular program.",
  "Ma journée": "My day", "Mes rapports": "My reports", "Vue d'ensemble": "Overview", "Rapports à revoir": "Reports to review",
  "Terrain": "Field", "Installer Stride": "Install Stride", "Mode avancé": "Advanced mode", "Surveillance (anciens modules)": "Surveillance (legacy modules)",
  "Rapport du jour": "Daily report",
  "Saisissez vos chiffres et vos notes du jour : les rapports quotidien, hebdomadaire et mensuel sont produits automatiquement.": "Enter today's figures and notes: daily, weekly and monthly reports are produced automatically.",
  "Laissez vide ce que vous n'avez pas. Les champs hebdomadaires et mensuels ne sont à remplir qu'en fin de période.": "Leave blank what you don't have. Weekly and monthly fields are only filled at the end of the period.",
  "Pré-remplir depuis mon rapport Word": "Pre-fill from my Word report",
  "chiffres et": "figures and", "textes pré-remplis. Vérifiez puis enregistrez.": "texts pre-filled. Check, then save.", "Import impossible.": "Import failed.",
  "Aires de santé d'appui": "Supported health areas",
  "Une ligne par aire de santé suivie (hotspots). Les taux se calculent automatiquement.": "One row per followed health area (hotspots). Rates are computed automatically.",
  "Ajouter une aire": "Add an area", "Aucune aire de santé ajoutée.": "No health area added.", "Aire de santé": "Health area",
  "Alertes notifiées": "Alerts notified", "Alertes attendues": "Expected alerts", "Contacts vus": "Contacts seen", "Contacts à suivre": "Contacts to follow",
  "Alertes": "Alerts", "Contacts": "Contacts", "Observation": "Observation",
  "Observation (ex. bonne notification par rapport à hier)": "Observation (e.g. good notification compared to yesterday)",
  "Remontées des zones de santé": "Feedback from health zones",
  "Observations, défis, recommandations et perspectives de tous les épidémiologistes, en un seul fil. La coordination suit chaque point jusqu'à sa résolution.": "Observations, challenges, recommendations and outlook from every epidemiologist in one feed. Coordination follows each point through to resolution.",
  "Nouveau": "New", "En cours": "In progress", "Résolu": "Resolved", "Statut mis à jour.": "Status updated.",
  "7 derniers jours": "Last 7 days", "30 derniers jours": "Last 30 days", "90 derniers jours": "Last 90 days", "12 mois": "12 months",
  "Toutes les provinces": "All provinces", "Toutes les zones de santé": "All health zones", "Tous les types": "All types",
  "Défis": "Challenges", "Observations": "Observations", "Perspectives": "Outlook", "Défi": "Challenge", "Recommandation": "Recommendation", "Perspective": "Outlook",
  "Aucune remontée pour ces filtres.": "No feedback for these filters.", "par": "by",
  "Cumul": "Cumulative", "Date du rapport": "Report date",
  "Actions SMART": "SMART actions", "Qualité des données": "Data quality", "Qualité des Données (ancien)": "Data Quality (legacy)", "Supervision": "Supervision",
  "Valeur d'origine → problème détecté → vérification suggérée → décision du superviseur → valeur approuvée. Les valeurs d'origine ne sont jamais écrasées.": "Original value → detected issue → suggested verification → supervisor decision → approved value. Original values are never overwritten.",
  "Réconciliation": "Reconciliation", "Dictionnaire des indicateurs": "Indicator dictionary", "À traiter": "Pending", "Acceptée": "Accepted", "Corrigée": "Corrected", "Rejetée": "Rejected", "Toutes": "All",
  "Aucune anomalie pour ce filtre.": "No anomaly for this filter.", "Règle": "Rule", "Valeur d'origine": "Original value", "Problème détecté": "Detected issue", "Vérification suggérée": "Suggested verification", "Décision": "Decision",
  "Valeur corrigée": "Corrected value", "Note de vérification": "Verification note", "Valeur confirmée": "Value confirmed", "Faux positif": "False positive", "Décision enregistrée.": "Decision saved.",
  "Indicateur": "Indicator", "Numérateur": "Numerator", "Dénominateur": "Denominator", "Agrégation": "Aggregation", "Périodes": "Periods", "Cible": "Target", "Calculé": "Computed", "Oui": "Yes",
  "Matrice SMART": "SMART matrix", "Registre des actions": "Action registry",
  "Chaque constat débouche sur une action, un responsable nommé, une échéance et un indicateur de vérification. Les actions échues non réalisées sont signalées.": "Every finding leads to an action, a named owner, a deadline and a verification indicator. Overdue actions are flagged.",
  "Nouvelle action": "New action", "Actions": "Actions", "En retard": "Overdue", "% réalisées (échues)": "% done (due)", "% en retard": "% overdue", "Aucune action.": "No action.",
  "Réalisé": "Done", "Bloqué": "Blocked", "Reporté": "Postponed", "Action": "Action", "Problème / constat": "Problem / finding", "Action concrète à mener": "Concrete action to take", "Responsable / point focal": "Owner / focal point",
  "Indicateur de vérification (ex. suivi > 90 % sur 2 semaines)": "Verification indicator (e.g. follow-up > 90% for 2 weeks)", "Province": "Province", "Annuler": "Cancel", "Enregistrer l'action": "Save action", "Action créée.": "Action created.",
  "Cause de l'écart (obligatoire pour une action non réalisée)": "Reason for the gap (required for an action not done)", "Voir l'action SMART": "View SMART action", "Créer une action SMART": "Create SMART action",
  "Suivi des actions": "Action follow-up", "Gestion des utilisateurs": "User management", "Importer un rapport Word": "Import a Word report", "Rapports existants": "Existing reports",
  "Chaque constat débouche sur une action, un responsable, une échéance et un indicateur de vérification. Les responsables reçoivent chaque lundi la liste de leurs actions en retard.": "Every finding leads to an action, an owner, a deadline and a verification indicator. Owners receive the list of their overdue actions every Monday.",
  "E-mail du responsable (pour les rappels du lundi)": "Owner e-mail (for Monday reminders)",
  "Pour créer les comptes des participants, renseignez pour chacun : nom complet ; adresse e-mail professionnelle ; rôle ; province d'affectation ; zone de santé (facultative). Une personne par ligne.": "To create participant accounts, enter for each: full name; professional e-mail; role; province; health zone (optional). One person per line.",
  "Déposez votre rapport habituel (Word ou PDF). Les chiffres trouvés s'affichent dans un tableau : vous confirmez ou corrigez chaque valeur avant l'enregistrement. Le document original est conservé comme pièce justificative.": "Drop your usual report (Word or PDF). The figures found are listed in a table: you confirm or correct each value before saving. The original document is kept as supporting evidence.",
  "valeurs extraites. Vérifiez chaque ligne avant d'enregistrer.": "values extracted. Check each line before saving.", "Lecture du document…": "Reading the document…", "Choisir un fichier .docx ou .pdf": "Choose a .docx or .pdf file",
  "Document": "Document", "valeurs confirmées": "values confirmed", "Valeur lue": "Value read", "Valeur à enregistrer": "Value to save", "Vérification": "Check", "ambigu dans le texte": "ambiguous in the text", "Confirmée": "Confirmed", "Confirmer": "Confirm",
  "Aucun chiffre reconnu dans ce document.": "No figure recognised in this document.", "Textes repris du rapport": "Texts taken from the report", "Aucun texte repris.": "No text taken.",
  "Enregistrer les valeurs confirmées": "Save confirmed values", "Confirmez (ou videz) chaque ligne pour pouvoir enregistrer.": "Confirm (or clear) each line to be able to save.", "Saisie enregistrée à partir du rapport importé.": "Entry saved from the imported report.",
  "Saisie du": "Entry of", "enregistrée. Document original conservé, validation tracée à votre nom.": "saved. Original document kept, validation recorded under your name.", "point(s) de qualité à vérifier par le superviseur :": "quality point(s) for the supervisor to check:", "Ouvrir la saisie": "Open the entry", "Importer un autre rapport": "Import another report",
  "Analyse du mois": "Month analysis", "Courbe épidémique, répartition par zone, matrice SMART, suivi M-1 et priorités, produits à partir des données saisies.": "Epidemic curve, zone breakdown, SMART matrix, M-1 follow-up and priorities, built from entered data.",
  "Analyse construite uniquement à partir des saisies quotidiennes et du registre des actions.": "Analysis built only from daily entries and the action registry.", "saisies": "entries", "agents": "agents", "complétude": "completeness", "Exporter en Word": "Export to Word",
  "Courbe épidémique (cas confirmés par jour)": "Epidemic curve (confirmed cases per day)", "Aucune saisie quotidienne sur la période.": "No daily entry over the period.", "Répartition par zone de santé": "Breakdown by health zone", "Nouveaux cas": "New cases", "Cumul (date)": "Cumulative (date)",
  "Matrice SMART du mois": "SMART matrix of the month", "Aucune action créée ce mois.": "No action created this month.", "Problème": "Problem", "Responsable": "Owner", "Échéance": "Deadline", "Statut": "Status",
  "Suivi des actions du mois précédent (M-1)": "Follow-up of last month's actions (M-1)", "Aucune action du mois précédent.": "No action from last month.", "Priorités du mois suivant": "Priorities for next month", "Aucune action ouverte à échéance le mois prochain.": "No open action due next month.", "tous": "all",
  "Nouveau rapport mensuel": "New monthly report", "Rapport mensuel": "Monthly report",
  "En un coup d'œil": "At a glance", "Les chiffres essentiels de votre niveau, calculés à partir des saisies validées.": "The key figures for your level, computed from validated entries.",
  "Agent": "Agent", "Zone de santé": "Health zone", "National": "National", "Qualité et supervision": "Quality and supervision", "Tableau de bord détaillé": "Detailed dashboard",
  "Saisie du jour": "Today's entry", "Faite": "Done", "À faire": "To do", "Jours consécutifs": "Consecutive days", "Saisies ce mois": "Entries this month", "Rapports retournés": "Returned reports", "Brouillons à soumettre": "Drafts to submit", "Mes actions ouvertes": "My open actions", "Points qualité (30 j)": "Quality points (30 d)",
  "Complétude des saisies": "Entry completeness", "Alertes vérifiées": "Alerts verified", "Suivi des contacts": "Contact follow-up", "Létalité cumulée": "Cumulative CFR", "Nouveaux cas confirmés": "New confirmed cases", "Rapports à valider": "Reports to validate", "Points qualité à traiter": "Quality points to handle", "Actions en retard": "Overdue actions",
  "Mes 14 dernières saisies": "My last 14 entries", "point(s) qualité": "quality point(s)", "Aucune saisie.": "No entry.", "Ouvrir ma journée": "Open my day", "Mes rapports récents": "My recent reports",
  "Comparaison des zones et provinces": "Zones and provinces comparison", "Comparaison des zones de santé": "Health zones comparison", "Zone": "Zone", "Saisies": "Entries", "Complétude": "Completeness", "Suivi contacts": "Contact follow-up", "Cas": "Cases", "Qualité": "Quality", "Dernière saisie": "Last entry",
  "Aucune saisie sur la période.": "No entry over the period.", "Zones sans aucune saisie": "Zones with no entry", "Aucune action en retard.": "No overdue action.", "Difficultés signalées cette semaine": "Challenges reported this week", "Aucune difficulté signalée.": "No challenge reported.",
  "Répartition par âge et sexe": "Breakdown by age and sex", "Hommes": "Men", "Femmes": "Women", "Les sections se remplissent à partir des saisies quotidiennes. Complétez ce qui manque, puis soumettez au superviseur.": "Sections are filled from daily entries. Complete what is missing, then submit to the supervisor.", "Date des chiffres du jour": "Date of today's figures", "si veille": "if previous day",
  "Date de référence des cumuls (DHIS2)": "Cumulative reference date (DHIS2)", "Cumuls datés de plus de 3 jours : à actualiser.": "Cumulative figures older than 3 days: please refresh.",
  "Marquez « ? » une donnée réellement inconnue : elle ne sera pas comptée comme zéro.": "Mark \"?\" a truly unknown value: it will not be counted as zero.",
  "Donnée inconnue": "Unknown value", "Inconnu": "Unknown",
  "Une ligne par activité : catégorie, résultat ou livrable, participants si formation.": "One row per activity: category, result or deliverable, participants if training.",
  "Ajouter": "Add", "Activité et résultat": "Activity and result", "Lieu (ZS / AS)": "Location (HZ / HA)", "Livrable": "Deliverable", "participants": "participants",
  "Constat, cause racine, impact sur la riposte et criticité. Les actions correctives se formulent dans « Recommandations ».": "Finding, root cause, impact on the response and criticality. Corrective actions go under \"Recommendations\".",
  "Constat / dysfonctionnement": "Finding / dysfunction", "Cause racine": "Root cause", "Impact sur la riposte": "Impact on the response", "Constat": "Finding", "Impact": "Impact", "Criticité": "Criticality",
  "Élevée": "High", "Moyenne": "Medium", "Faible": "Low",
  "Canal de collecte alternatif": "Alternative collection channel",
  "Déployez le formulaire quotidien Stride dans KoboToolbox (gratuit, hors ligne) et rapatriez les soumissions dans Stride. Le jeton reste côté serveur.": "Deploy the Stride daily form in KoboToolbox (free, offline) and pull submissions into Stride. The token stays server-side.",
  "Formulaire XLSForm": "XLSForm", "Les noms des questions sont identiques aux variables Stride : aucune correspondance manuelle. Importez ce fichier dans KoboToolbox (Nouveau › Importer un XLSForm), puis déployez.": "Question names equal Stride variables: no manual mapping. Import this file in KoboToolbox (New › Import XLSForm), then deploy.",
  "Télécharger le XLSForm (Épidémiologie)": "Download the XLSForm (Epidemiology)", "Connexion au serveur Kobo": "Kobo server connection", "Serveur": "Server", "Jeton API": "API token", "configuré": "configured",
  "Compte › Sécurité › Clé API": "Account › Security › API key", "Identifiant du formulaire (asset UID)": "Form identifier (asset UID)", "Paramètres enregistrés.": "Settings saved.", "Tester la connexion": "Test connection",
  "formulaire(s) trouvé(s)": "form(s) found", "soumissions": "submissions", "Utiliser": "Use", "Synchronisation": "Synchronisation",
  "Chaque soumission devient une saisie quotidienne Stride, rattachée à l'agent via l'e-mail renseigné dans le formulaire (ou le nom d'utilisateur Kobo de son compte).": "Each submission becomes a Stride daily entry, linked to the agent via the e-mail given in the form (or the Kobo username on their account).",
  "Dernière synchronisation": "Last synchronisation", "créée(s)": "created", "mise(s) à jour": "updated", "non rattachée(s)": "unmatched", "Synchroniser les nouvelles soumissions": "Sync new submissions", "Tout resynchroniser": "Resync everything",
  "soumissions traitées": "submissions processed", "soumission(s) non rattachée(s) à un compte Stride": "submission(s) not linked to a Stride account", "sans e-mail": "no e-mail",
  "Identifiants du mode autonome définis à l'installation (par défaut admin@stride.local / Admin@Stride2026). Les autres comptes se créent ensuite dans Administration.": "Standalone-mode credentials are set during installation (default admin@stride.local / Admin@Stride2026). Other accounts are then created in Administration.",
};
